




























































import { Component, Vue } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatable.vue'
import { CommissionRecordsService, ReportLogDTO, CommissionStatementDTO } from '../../api'
import { inject } from 'inversify-props'
import { IDateService } from '@master/services/IDateService'
import ViewPolicyPlaceHolderSection from '@core/pages/new-business-register/components/policy/ViewPolicyPlaceHolderSection.vue'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import { FinancingPaymentStructure } from '@master/enum/AdviserFinancingEnum'
import AppDialog from '@core/components/AppDialog.vue'
import AppDateInput from '@core/components/AppDateInput.vue'
import AppModal from '@core/components/AppModalV2.vue'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { downloadCSVFile } from '@core/services/CSVService'
import TheCommissionStatement from '@core/components/TheCommissionStatement.vue'

@Component({
  components: {
    AppDatatable,
    ViewPolicyPlaceHolderSection,
    AppDialog,
    AppDateInput,
    AppModal,
    AppForm,
    TheCommissionStatement
  }
})
export default class StatementGeneratorLog extends Vue {
  @inject()
  private dateService: IDateService

  @inject()
  private sharedVariable: SharedVariable

  valueDate: number = undefined
  showValueDatePrompt = false
  showStatementDetailsModal = false
  selectedToViewDetails: CommissionStatementDTO = null

  loadingList = false
  detailLoadingList = false
  private reportLog: ReportLogDTO[] = []
  uiService: UIService
  commissionRecordReports: CommissionStatementDTO[] = []
  txtSearch = ''
  showDetail = false
  private detailsTableBatchId = ''

  statementModalStructure: FormStructure<CommissionStatementDTO>[] = []

  get giroReportValueDate () {
    return this.valueDate
  }

  set giroReportValueDate (value) {
    this.valueDate = value
  }

  get reportLogColumn () {
    return [
      {
        label: 'Statement Run Number',
        field: 'statementRunNumber'
      },
      {
        label: 'Status',
        field: 'status'
      },
      {
        label: 'Batch',
        field: 'batch'
      },
      {
        label: 'From (Statement Date)',
        field: 'from'
      },
      {
        label: 'To (Statement Date)',
        field: 'to'
      },
      {
        label: 'Executed On',
        field: 'runTimestamp'
      },
      {
        label: 'Number Processed',
        field: 'numberProcessed'
      },
      {
        label: 'Duration',
        field: 'duration'
      }
    ]
  }

  get reportLogData () {
    return this.reportLog.map(log => {
      const { ctm, utm, statementRunNumber, runTimestamp, fromTimestamp, toTimestamp, status, numberProcessed, batch, pky } = log
      const statusText = status === 1 ? 'Complete' : 'Incomplete'
      return {
        statementRunNumber,
        status: statusText,
        batch: batch || 'All',
        from: this.dateService.format(fromTimestamp, 'YYYY-MM-DD'),
        to: this.dateService.format(toTimestamp, 'YYYY-MM-DD'),
        runTimestamp: this.dateService.format(runTimestamp, 'YYYY-MM-DD HH:mm:ss'),
        numberProcessed,
        duration: status === 1 ? this.parseMillisecondsIntoReadableTime(utm - ctm) : null,
        emit: true,
        batchId: pky
      }
    })
  }

  parseMillisecondsIntoReadableTime (milliseconds: number) {
    // Get hours from milliseconds
    const hours = milliseconds / (1000 * 60 * 60)
    const absoluteHours = Math.floor(hours)
    const h = `0${absoluteHours}`.slice(-2)

    // Get remainder from hours and convert to minutes
    const minutes = (hours - absoluteHours) * 60
    const absoluteMinutes = Math.floor(minutes)
    const m = `0${absoluteMinutes}`.slice(-2)

    // Get remainder from minutes and convert to seconds
    const seconds = (minutes - absoluteMinutes) * 60
    const absoluteSeconds = Math.floor(seconds)
    const s = `0${absoluteSeconds}`.slice(-2)

    return h + ':' + m + ':' + s
  }

  private convertToCurrency (value, currencySymbol) {
    if (!value && value !== 0) return ''
    return currencySymbol + Number(value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }

  get isAllReportPublished () {
    return this.commissionRecordReports.every(report => report.published)
  }

  async loadDetailsTable () {
    this.detailLoadingList = true
    this.showDetail = true
    const data = await CommissionRecordsService.getReportListByBatchId(Number(this.detailsTableBatchId))
    this.commissionRecordReports = data

    if (!data) {
      this.showDetail = false
    }

    this.detailLoadingList = false
  }

  async statementRowOnClick (event) {
    if (!event.batchId) {
      return
    }
    this.detailsTableBatchId = event.batchId
    await this.loadDetailsTable()
  }

  async toUpdatePublishingRecord (published: boolean) {
    const confirmation = await this.uiService.confirm.show({
      message: 'Please confirm to ' + (published ? 'Publish' : 'Unpublish') + (this.commissionRecordReports.length < 2 ? ' this record.' : ' all of these records.'),
      type: 'warning'
    })
    if (!confirmation) {
      return
    }

    const targetOids = this.commissionRecordReports.map(record => record.oid)
    this.detailLoadingList = true
    await CommissionRecordsService.updatePublishedStatus({
      oids: targetOids,
      published: published
    })

    // reload and unselect
    await this.loadDetailsTable()
    this.detailLoadingList = false
  }

  setValueDate (event) {
    this.giroReportValueDate = event
  }

  async confirmValueDate () {
    if (!this.valueDate) {
      this.dialogIsClose()
      return
    }
    try {
      const filesData = await CommissionRecordsService.getGiroReport(Number(this.detailsTableBatchId), this.valueDate)

      this.downloadFile(filesData)
    } catch (error) {
      await this.uiService.alert.show({
        type: 'warning',
        message: error?.message || 'Fail to generate GiroReport'
      })
    }

    this.dialogIsClose()
  }

  downloadFile (filesData) {
    Object.keys(filesData).forEach(fileKey => {
      const fileName = FinancingPaymentStructure[fileKey] || 'NULL'
      const blob = new Blob([filesData[fileKey]], { type: 'text/plain' })
      const elem = window.document.createElement('a')
      elem.href = window.URL.createObjectURL(blob)
      elem.download = `${fileName}.txt`
      document.body.appendChild(elem)
      elem.click()
      document.body.removeChild(elem)
    })
  }

  seExportColumnStatement (structure) {
    this.statementModalStructure = structure.columnData
  }

  viewStatementDetails (event) {
    this.selectedToViewDetails = event
    this.showStatementDetailsModal = true
  }

  exportRecordDetailsCSV () {
    const column = ['Adviser Company Code', 'Payees', 'Generated On', 'Batch', 'Taxable(Non-Payable)', 'Open Balance', 'Personal Commission', 'Income/Deduction', 'Payout Amount', 'Close Balance', 'Overriding Open Balance', 'Overriding Commission', 'Overriding Payout Amount', 'Overriding Close Balance', 'Total Amount', 'Payment Structure', 'Status']
    console.log(this.commissionRecordReports)

    const data = this.commissionRecordReports.map(record => {
      // the key should same as column
      return {
        // eslint-disable-next-line dot-notation
        'Adviser Company Code': record['adviserCompanyCode'],
        Payees: record.payee,
        'Generated On': this.dateService.format(record.ctm, 'YYYY-MM-DD'),
        Batch: record.batch,
        'Taxable(Non-Payable)': this.convertToCurrency(record.nonPayableAmount, ''),
        'Open Balance': this.convertToCurrency(record.personalOpenBalance, ''),
        'Personal Commission': this.convertToCurrency(record.personalCommission, ''),
        'Income/Deduction': this.convertToCurrency(record.incomeDeductionAmount, ''),
        'Payout Amount': this.convertToCurrency(record.personalPayoutAmount, ''),
        'Close Balance': this.convertToCurrency(record.personalCloseBalance, ''),
        'Overriding Open Balance': this.convertToCurrency(record.overridingOpenBalance, ''),
        'Overriding Commission': this.convertToCurrency(record.overridingCommission, ''),
        'Overriding Payout Amount': this.convertToCurrency(record.overridingPayoutAmount, ''),
        'Overriding Close Balance': this.convertToCurrency(record.overridingCloseBalance, ''),
        // eslint-disable-next-line dot-notation
        'Total Amount': this.convertToCurrency(record['totalEarnAmount'], ''),
        'Payment Structure': FinancingPaymentStructure[record?.paymentStructure] || '',
        Status: record.published ? 'Published' : 'Unpublished'
      }
    })

    downloadCSVFile(column, data, 'Statement')
  }

  dialogIsClose () {
    this.giroReportValueDate = undefined
    this.showValueDatePrompt = false
  }

  async downloadGiroReport () {
    if (!this.isAllReportPublished) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'All report must be published before generate giro report.'
      })
    }

    this.showValueDatePrompt = true
  }

  async mounted () {
    this.reportLog = await CommissionRecordsService.getReportLog()
    this.uiService = this.sharedVariable.uiService
  }
}

